<template>
  <el-dialog
    v-model="store.showModal"
    
    :class="`donation-style-${(dstyle || 1)} ${store.config.wrapper_class}`"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @close="
      $emit('close');
    "
    modal-class="wpcm-wrapper"
    :show-close="false"
    :destroy-on-close="true"
  >
    <span class="closep" slot="title" @click="store.showModal = false"
      ><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"></path></svg></span>
    <div class="dialog-content" v-loading="store.loading">
      <modal-template v-if="store.components" :config="store.config" :currentStep="store.step">
        <template v-for="(slotData, slot) in groupBySlots(store.components)" v-slot:[`${slot}`]>
          <template v-for="comp in slotData">
            <modal-view :comp="comp"></modal-view>
          </template>
        </template>
      </modal-template>

      <div class="mt-4 text-center single-proced-btn" style="display: none;">
        <el-button
          :class="[store.config.proceed_classes || 'proceed btn']"
          @click="store.next()"
          v-if="store.step < store.config.steps"
          >{{ store.config.proceed && "Proceed" }}</el-button
        >
        <el-button
          :class="[store.config.proceed_classes || 'proceed btn']"
          @click="submit()"
          v-else
          >{{ store.config.donate_now }}</el-button
        >
        <el-button
          :class="[store.config.proceed_classes || 'proceed btn']"
          @click="store.back()"
          v-if="store.step > 1 && store.config.show_back_btn"
          >{{ store.config.back_text && "Go Back" }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';
import descriptor from '../utils/rules'
import ModalView from "./ModalView.vue";

import ModalTemplate from "./ModalTemplate.vue";
import { groupBySlots } from '../utils/helper';

const _ = globalThis._;
const store = useDonationFormsStore();
const props = defineProps(['id', 'dstyle']);

const submit = () => {
  const { $state } = store;
  store.validate({ rules: descriptor, fields: $state })
    .then((res) => {
      store.submit()
    })
    .catch(({fields, errors}) => {
      validation_catch(fields, errors);
    });
};
const validation_catch = (fields: Record<string, any>, errors: any[]) => {
  _.each(fields, (field) => {
    setTimeout(() => {
      ElNotification({
        type: 'error',
        title: "Error",
        message: field[0].message,
        offset: 40,
      });
    }, 300);
  });
};

onMounted(async() => {
  await store.getData({ vm: props });
    if (store.showModal) {
    }
});


</script>
